import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

// Generic Bootstrap modal controller for Turbo Drive compatibility.
// data-bs-dismiss="modal" is unreliable after Turbo navigations,
// so we handle show/hide through Stimulus instead.
//
// Usage:
//   <div class="modal" data-controller="bs-modal">
//     <button data-action="click->bs-modal#hide">Close</button>
//   </div>
export default class BsModalController extends Controller {
  hide() {
    const instance = Modal.getInstance(this.element);
    if (instance) instance.hide();
  }
}
